<template lang="pug">
div.animated.fadeIn
  // conclusion by duration
  b-card
    div.row
      div.col-sm-4
      div.col-sm-8
        div.dateRangePickerContainer
          i(class="fa fa-calendar")
          date-range-picker.ml-2.dateRangePicker(ref="ref" :options="options")
          i(class="fa fa-caret-down")
    br
    div(id='graphContainer' style='height: 500px')
</template>

<script>
// import { db } from '@/firebase'
import echarts from 'echarts'
import $ from 'jquery'
var moment = require('moment')
// const anaRef = db.ref('analytics')

export default {
  name: 'dashboard',
  data() {
    let quarter = moment().quarter()
    let year = moment().startOf('year').format('YYYY')
    let startDateString = ''
    let endDateString = ''
    if (quarter == 1) {
      startDateString = `${year}-01-01`
      endDateString = `${year}-03-31`
    } else if (quarter == 2) {
      startDateString = `${year}-04-01`
      endDateString = `${year}-06-30`
    } else if (quarter == 3) {
      startDateString = `${year}-07-01`
      endDateString = `${year}-09-30`
    } else if (quarter == 4) {
      startDateString = `${year}-10-01`
      endDateString = `${year}-12-31`
    }
    return {
      initialise: true,
      userAccessLevel: this.$store.state.profile.accessLevel,
      // for date range picker
      options: {
        startDate: moment(startDateString),
        endDate: moment(endDateString),
        locale: {
          format: 'DD/MM/YYYY',
        },
        showCustomRangeLabel: false,
        ranges: {
          [`${year} - Q4`]: [moment(`${year}-10-01`), moment(`${year}-12-31`)],
          [`${year} - Q3`]: [moment(`${year}-07-01`), moment(`${year}-09-30`)],
          [`${year} - Q2`]: [moment(`${year}-04-01`), moment(`${year}-06-30`)],
          [`${year} - Q1`]: [moment(`${year}-01-01`), moment(`${year}-03-31`)],
          [`${year - 1} - Q4`]: [moment(`${year - 1}-10-01`), moment(`${year - 1}-12-31`)],
          [`${year - 1} - Q3`]: [moment(`${year - 1}-07-01`), moment(`${year - 1}-09-30`)],
          [`${year - 1} - Q2`]: [moment(`${year - 1}-04-01`), moment(`${year - 1}-06-30`)],
          [`${year - 1} - Q1`]: [moment(`${year - 1}-01-01`), moment(`${year - 1}-03-31`)],
          [`${year - 2} - Q4`]: [moment(`${year - 2}-10-01`), moment(`${year - 2}-12-31`)],
          [`${year - 2} - Q3`]: [moment(`${year - 2}-07-01`), moment(`${year - 2}-09-30`)],
          [`${year - 2} - Q2`]: [moment(`${year - 2}-04-01`), moment(`${year - 2}-06-30`)],
          [`${year - 2} - Q1`]: [moment(`${year - 2}-01-01`), moment(`${year - 2}-03-31`)],
        },
      },
      startDateString,
      endDateString,
      yAxisLabels: [],
      sliderEndPoint: '',
      sliderStartPoint: '',
      option: null,
      cellSize: [60, 50],
      pieRadius: 18,
      pieInitialized: false,
      app: {},
    }
  },
  mounted: async function() {
    const that = this
    var dom = document.getElementById('graphContainer')
    var myChart = echarts.init(dom)
    const el = $(this.$refs.ref.$el)

    var year = 2019
    // sample data
    var date = +echarts.number.parseDate(year + '-01-01')
    var end = +echarts.number.parseDate((+year + 1) + '-01-01')
    var dayTime = 3600 * 24 * 1000
    var data = []
    for (var time = date; time <= end; time += dayTime) {
      let agentNumber = Math.floor(Math.random() * 100)
      let botNumber = Math.floor(Math.random() * 1000)
      let userNumber = Math.floor(Math.random() * 1000)
      data.push([
        echarts.format.formatTime('yyyy-MM-dd', time),
        userNumber,
        botNumber,
        agentNumber,
      ])
    }
    this.fullData = data
    this.setOption(data)
    if (this.option && typeof this.option === 'object') {
      myChart.setOption(this.option, true)
    }
    if (!this.app.inNode) {
      setTimeout(function () {
        this.pieInitialized = true
        myChart.setOption({series: that.getPieSeries(data, myChart)})
      }, 10)
    }

    el.on('apply.daterangepicker', (event, picker) => {
      this.endDateString = `${picker.endDate.format('YYYY-MM-DD')}`
      this.startDateString = `${picker.startDate.format('YYYY-MM-DD')}`
      var date = +echarts.number.parseDate(this.startDateString)
      var end = +echarts.number.parseDate(this.endDateString)
      var data = []
      const that = this
      for (var time = date; time <= end; time += dayTime) {
        let agentNumber = Math.floor(Math.random() * 100)
        let botNumber = Math.floor(Math.random() * 1000)
        let userNumber = Math.floor(Math.random() * 1000)
        data.push([
          echarts.format.formatTime('yyyy-MM-dd', time),
          userNumber,
          botNumber,
          agentNumber,
        ])
      }
      this.setOption(this.fullData)
      myChart.clear()
      myChart.setOption(this.option, false)
      myChart.setOption({series: that.getPieSeries(data, myChart)})
    })
  },
  methods: {
    getPieSeries(scatterData, chart) {
      const that = this
      return echarts.util.map(scatterData, function (item, index) {
        var center = chart.convertToPixel('calendar', item)
        return {
          id: index + 'pie',
          type: 'pie',
          color: ['#6fdebd', '#ffb994', '#afb2e3'],
          center: center,
          label: {
            normal: {
              formatter: '{c}',
              position: 'inside',
            },
          },
          radius: that.pieRadius,
          data: [
            {name: 'Visitor', value: item[1]},
            {name: 'Bot', value: item[2]},
            {name: 'Agent', value: item[3]},
          ],
        }
      })
    },
    setOption(scatterData) {
      this.option = {
        backgroundColor: '#fff',
        animation: false,
        title: {
          top: 5,
          left: 5,
          text: 'Daily Interactions',
        },
        tooltip: {
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1,
          transitionDuration: 0.1,
          borderColor: '#ccc',
          padding: 10,
          textStyle: {color: '#000'},
          position: 'top',
        },
        toolbox: {
          orient: 'vertical',
          top: 5,
          right: 20,
          showTitle: false,
          feature: {
            dataZoom: {
              yAxisIndex: false,
              show: false,
            },
            restore: {},
            saveAsImage: {},
          },
        },
        legend: {
          data: ['Visitor', 'Bot', 'Agent'],
          orient: 'horizontal',
          align: 'right',
          right: 100,
          top: 10,
        },
        calendar: {
          top: 'middle',
          width: '85%',
          orient: 'horizontal',
          cellSize: this.cellSize,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#666',
              width: 2,
              type: 'solid',
            },
          },
          yearLabel: {
            margin: 50,
            show: true,
            textStyle: { margin: '1px', fontSize: 30 },
          },
          dayLabel: {
            margin: 15,
            firstDay: 1,
            nameMap: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            textStyle: {
              fontSize: 15,
              fontWeight: 'bold',
            },
          },
          monthLabel: {
            position: 'end',
            show: true,
            textStyle: {
              fontSize: 24,
            },
          },
          range: [this.startDateString, this.endDateString],
        },
        series: [{
          id: 'label',
          type: 'scatter',
          coordinateSystem: 'calendar',
          symbolSize: 1,
          label: {
            normal: {
              show: true,
              formatter: function (params) {
                return echarts.format.formatTime('dd', params.value[0])
              },
              offset: [-this.cellSize[0] / 2 + 10, -this.cellSize[1] / 2 + 10],
              textStyle: {
                color: '#333',
                fontSize: 14,
                fontWeight: 'bold',
              },
            },
          },
          data: scatterData,
        }],
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Analytics/DailyInteractions.vue?e6f2162c